import { apiRequest } from '@scc/lib'
import type {
  LaunchTemplateRepository, CreateLaunchTemplateInput, UpdateLaunchTemplateInput,
} from '@/data/repositories/types'
import type { LaunchTemplate, ProjectionOutputs, TemplateConfig, WizardPreset } from '@/modules/launch/templating-types'

const base = (agencyId: number) => `/agencies/${agencyId}/launch-templates`

export function createApiLaunchTemplateRepository(): LaunchTemplateRepository {
  return {
    // Agency-scoped
    list: (agencyId) =>
      apiRequest<LaunchTemplate[]>(base(agencyId)),
    get: (agencyId, id) =>
      apiRequest<LaunchTemplate>(`${base(agencyId)}/${id}`),
    create: (agencyId, input: CreateLaunchTemplateInput) =>
      apiRequest<LaunchTemplate>(base(agencyId), { method: 'POST', body: input }),
    update: (agencyId, id, input: UpdateLaunchTemplateInput) =>
      apiRequest<LaunchTemplate>(`${base(agencyId)}/${id}`, { method: 'PUT', body: input }),
    remove: async (agencyId, id) => {
      await apiRequest<void>(`${base(agencyId)}/${id}`, { method: 'DELETE' })
    },
    computeTemplate: (agencyId, config: TemplateConfig) =>
      apiRequest<ProjectionOutputs>(`${base(agencyId)}/compute`, { method: 'POST', body: { config } }),
    listPresets: (agencyId) =>
      apiRequest<WizardPreset[]>(`${base(agencyId)}/presets`, { method: 'GET' }),
  }
}
